import { withCompInfo } from '@wix/editor-elements-integrations'
import type { AccordionContainerProps } from './AccordionContainer'

export const props = withCompInfo<AccordionContainerProps, any>()(
	// @ts-ignore
	['hasResponsiveLayout', 'responsiveContainerProps', 'containerRootClassName'],
	// @ts-ignore
	({ hasResponsiveLayout, responsiveContainerProps: containerProps, containerRootClassName }) => {
		if (hasResponsiveLayout) {
			return {
				containerProps,
				containerRootClassName,
			}
		} else {
			return {}
		}
	}
)
